<template>
  <div class="login-page">
    <div class="login-page_left">
    </div>
    <div class="login-page_right">
      <div class="login-page_right_container">
        <div class="login-page_right_container_title">第一时刻，掌握世界</div>
        <div class="login-page_right_container_header">
          登录智目舆情
        </div>
        <div class="login-page_right_container_content">
          <div class="login-page_right_container_content_title">手机号/用户名</div>
          <div class="login-page_right_container_content_input telNumber row">
            <el-input
              v-model="loginTelNumber"
              @focus="loginInputFocus"
              :class="{'login-input-error':!loginError}"
              placeholder="请输入您的手机号或用户名"
            ></el-input>
          </div>
          <div class="login-page_right_container_content_title password">
            密码
          </div>
          <div class="login-page_right_container_content_input telNumber">
            <el-input
              v-model="loginPassword"
              :class="{'login-input-error':!loginError}"
              type="password"
              placeholder="请输入您的密码"
              @keyup.enter.native="login"
            ></el-input>
          </div>
          <div class="error-message" :class="{isError:loginError}">{{loginErrorMessage}}</div>
        </div>
        <button class="login-page_right_container_btn"  @click="login">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import authQuery from '@/rest/authQuery';
import localStorageHelper from '@/helpers/localStorageHelper';
import { AUTH_TOKEN_KEY, USER_NAME, PHONE_NUMBER } from '@/helpers/constants';

export default {
  name: 'loginPage',
  data() {
    return {
      isLoginPage: true,
      loginTelNumber: '',
      loginPassword: '',
      loginErrorMessage: '',
      verifyCode: '',
      loginError: true,
      errorMessage: ''
    };
  },
  methods: {
    login() {
      if (this.loginTelNumber && this.loginPassword) {
        authQuery.login(this.loginTelNumber, this.loginPassword).then(
          res => {
            if (res.data.status === -1) {
              this.loginError = false;
              this.loginErrorMessage = res.data.msg;
            } else if (res.data.status === 0) {
              localStorageHelper.setItem(AUTH_TOKEN_KEY, res.data.token);
              localStorageHelper.setItem(USER_NAME, res.data.username);
              localStorageHelper.setItem(PHONE_NUMBER, res.data.phoneNumber);
              this.$router.push({
                path: '/'
              });
            } else if (res.data.status === -2) {
              if (/^1[3456789]\d{9}$/.test(this.loginTelNumber)) {
                this.$router.push({
                  path: '/perfect-user',
                  query: { loginTelNumber: this.loginTelNumber }
                });
              } else {
                this.$router.push({
                  path: '/perfect-user',
                  query: { username: this.loginTelNumber }
                });
              }
            }
          },
        );
      } else {
        this.loginError = false;
        this.loginErrorMessage = '用户名或密码不能为空请重新输入';
      }
    },
    goRegisterPage() {
      this.$router.push({ name: 'register-page' });
    },
    loginInputFocus() {
      this.loginErrorMessage = '';
      this.loginError = true;
    },

    loginInputBlur() {
      if (this.loginTelNumber === '') {
        this.loginError = false;
        this.loginErrorMessage = '手机号码不能为空';
      } else {
        this.loginError = true;
        this.loginErrorMessage = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../scss/color.scss";
@import "./../scss/mixin.scss";

.login-page {
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 840px;
  min-height: 550px;
  font-family:sans-serif;
  &_left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40%;
    height: 100%;
    background: url("./../assets/img/bg.jpg") no-repeat;
    background-size: cover;
    &_content {
      width: 156px;
      height: 233px;
      margin-top: -20%;
      &_logo {
        width: 156px;
        height: 162px;
        background: url("./../assets/img/login-logo.svg") no-repeat;
      }
      &_line {
        height: 1px;
        width: 64px;
        background: #ffffff;
        margin: 22px auto;
      }
      &_text {
        width: 156px;
        height: 22px;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: 1px;
        color: #fff;
        font-weight: normal;
        text-align: center;
      }
    }
  }
  &_right {
    position: relative;
    width: 60%;
    height: 100%;
    background: #333138;
    .register-btn {
      position: absolute;
      top: 6%;
      right: 10%;
      width: 76px;
      height: 48px;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
      background-color: #423f43;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
      &:hover{
        background: #45a8cc;
      }
      &:active{
        background: #368cab;
      }
    }
    &_container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translateX(-50%, -50%);
      -moz-transform: translateX(-50%, -50%);
      -webkit-transform: translateX(-50%, -50%);
      -o-transform: translateX(-50%, -50%);
      width: 486px;
      height: 452px;
      &_title {
        font-size: 28px;
        font-weight: bold;
        line-height: 40px;
        color: #ffffff;
        font-family:sans-serif;
      }
      &_header {
        margin-top: 7px;
        font-size: 16px;
        font-weight: 100;
        color: #ffffff;
        letter-spacing: 1.1px;
        a {
          letter-spacing: 1.1px;
          color: #4a90e2;
          text-decoration: none;
          float: right;
        }
      }
      &_content {
        padding-top: 68px;
        padding-bottom: 50px;
        &_title {
          height: 20px;
          font-size: 14px;
          color: #83898b;
          a {
            letter-spacing: 1.1px;
            color: #4a90e2;
            text-decoration: none;
            float: right;
          }
        }
        &_input {
          margin-top: 4px;
          /deep/ .el-input {
            .el-input__inner {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-left-width: 0;
              border-bottom-left-radius: 4px;
              border-top-left-radius: 4px;
              border-left-width: 4px;
              background-color: #27252a !important;
            }
          }
        }
        .password {
          margin-top: 32px;
        }
      }
      &_btn {
        width: 486px;
        height: 56px;
        background-color: #45a8cc;
        box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
        border-radius: 4px;
        font-size: 18px;
        color: #fff;
        border: none;
        &:focus {
          outline: 0;
        }
        &:hover {
          background-color: #3cbeed;
          box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
        }
        &:active {
          background-color: #368cab;
          box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
        }
        @include buttonEffect;
      }
      .forget-password {
        margin-top: 16px;
        display: block;
        width: 100%;
        letter-spacing: 1px;
        color: #4a90e2;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}
/deep/ .el-input {
  .el-input__inner {
    height: 48px;
    line-height: 48px;
    color: #fff;
    background: rgb(245, 250, 252);
    border: 1px solid transparent;
    border-color:#585659;
    border-right-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
    &::-webkit-input-placeholder {
      color: #b1c2c9;
      font-size: 14px;
    }
    &:hover {
      border-color: #585659;
      border: 1px solid #585659;
    }
    &:focus {
      border-color: #45a8cc;
    }
    &::-webkit-input-placeholder {
      color: #727273;
      font-size: 14px;
    }
  }
}
.login-input-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}
.tel-input-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}

.regist-tel-input-right {
  /deep/ .el-input__inner {
    border-color: #7ed321;
    &:hover {
      border-color: #7ed321;
    }
  }
}
.password-input-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}
.password-repeat-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}
.error-message {
  margin-top: 1px;
  height: 24px;
  padding-left: 8px;
  line-height: 24px;
  background-color: rgba(242, 114, 114, 0.2);
  border-radius: 4px;
  font-size: 14px;
  letter-spacing: 1px;
  color: #f27272;
}
.isError {
  visibility: hidden;
}
.password {
  /deep/ .el-input {
    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left-width: 0;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      border-left-width: 4px;
    }
  }
}
.telNumber {
  position: relative;
  .local-code {
    position: absolute;
    top: 14px;
    left: 16px;
    width: 100px;
    height: 20px;
    padding-left: 16px;
    line-height: 20px;
    font-size: 14px;
    color: #161e1f;
    z-index: 100;
    span {
      display: inline-block;
      width: 1px;
      height: 20px;
      position: absolute;
      top: 0px;
      right: 0;
      background: #585659;
    }
  }
  /deep/ .el-input {
    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left-width: 0;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      border-left-width: 4px;
      background-color: #27252a !important;
    }
  }
}
</style>
